<template>
  <span>
    <template v-for="(row, i) in data">
      <tg-agent-cell :key="i" :row="row"></tg-agent-cell>
      <template v-if="i < lastIndex">
        >
      </template>
    </template>
  </span>
</template>

<script>
import TgAgentCell from "@/components/slot/TgAgentCell";

export default {
  components: {
    TgAgentCell,
  },
  props: {
    data: Array,
  },
  computed: {
    lastIndex() {
      return this.data.length - 1;
    },
  },
};
</script>
